import { createTracker } from 'usage-tracker-anonymous';
import { makeUuid } from 'usage-tracker-core/common/helpers';
export const usageTracker = createTracker({
  allowUnauthed: true,
  standalone: true,
  properties: {
    deviceId: makeUuid
  }
});